import { createI18n } from "vue-i18n";
import cn from "./cn.js";
import en from "./en.js";
import es from "./es.js";
import jp from "./jp.js";
import mn from "./mn.js";
import pt from "./pt.js";
import ru from "./ru.js";
import th from "./th.js";
import hi from "./hi.js";
import kr from "./kr.js";
import pl from "./pl.js";
import fr from  "./fr.js"
import vi from "./vi.js"

export const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  globalInjection: true,
  messages: {
    en,
    cn,
    es,
    jp,
    mn,
    pt,
    ru,
    th,
    hi,
    kr,
    pl,
    fr,
    vi,
  },
});

export const { t, locale, messages, te } = i18n.global;
